<style scoped>
.action-buttons {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #eee;
  margin-top: 20px;
  padding-top: 15px;
}
</style>

<template>
   <div class="profile-info-fields-others">
      <div class="container" v-if="profileFields">
         <Collapse>
            <Panel :name="group.name" v-for="(group, index) in profileFields" :key="index" v-if="index < 6">
                  {{group.name}}
                  <div slot="content">
                     <div class="profile-info__content" v-for="(field, sub_index) in group.fields" :key="sub_index">
                        <ProfileInfoFileds :type="field.type"
                           :field-selections="field.options"
                           :slug="field.slug"
                           :field-value="checkIfEmptyField(profileInfo[group.group_slug], [field.slug])"
                           :label="field.label" v-on:saveData="onSave($event, group)"></ProfileInfoFileds>
                     </div>
                     <div class="action-buttons">
                        <Button type="primary" v-on:click="updateUserInfo(group)"
                           :disabled="disableSaveButton" :loading="updateLoader">Save</Button>
                     </div>
                  </div>
            </Panel>
         </Collapse>
      </div>
   </div>
</template>

<script>
import ProfileInfoFileds from "@/components/ProfileInfoFields";

export default {
  name: "ProfileInfoFieldsOthers",
  components: {
    ProfileInfoFileds
  },
  data() {
    return {
      triggeredFields: {},
      disableSaveButton: true
    };
  },
  computed: {
    profileFields() {
      return this.$store.state.user.userFields;
    },
    profileInfo() {
      return this.$store.state.user.info;
    },
    updateLoader() {
      return this.$store.state.user.isLoadingUserProfile;
    }
  },
  methods: {
    checkIfEmptyField(field, slug) {
      return field ? field[slug] : "";
    },

    onSave(data, group) {
      //set profile info value
      this.profileInfo[group.group_slug][data.slug] = data.value;
      this.triggeredFields[group.group_slug] = this.profileInfo[
        group.group_slug
      ];

      if (group.group_slug == "account") {
        this.triggeredFields[data.slug] = data.value;
      }

      this.disableSaveButton = false;
    },

    updateUserInfo() {
      let val = {
        id: this.profileInfo.id,
        data: this.triggeredFields
      };
      console.log(this.triggeredFields);
      this.$store.dispatch("user/updateUserInfo", val).then(response => {
        console.log(response);
        this.disableSaveButton = true;
        this.$Message({
          closable: true,
          // durationInSec:3,
          title: { content:'Updated' },
          icon: 'checkmark',
          message: { content: 'Profile Info updated.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });        
      });
    },

    displayUserFields(field) {
      switch (profileInfo.other.status){
        case 'Seaman':
          for(let i = 0; i<this.profileFields.length; i++){
            if( this.this.profileFields.group_slug == agency_info ||
              this.this.profileFields.group_slug == ngo_info ||
              this.this.profileFields.group_slug == overseas_info )
              this.profileFields.splice(i, 1)
          }
        break;
        case 'Family Member':
          for(let i = 0; i<this.profileFields.length; i++){
            if( this.this.profileFields.group_slug == agency_info ||
              this.this.profileFields.group_slug == ngo_info ||
              this.this.profileFields.group_slug == overseas_info ||
              this.this.profileFields.group_slug == seaman_info )
              this.profileFields.splice(i, 1)
          }
        break;
        case 'NGO':
          for(let i = 0; i<this.profileFields.length; i++){
            if( this.this.profileFields.group_slug == agency_info ||
              this.this.profileFields.group_slug == overseas_info ||
              this.this.profileFields.group_slug == seaman_info )
              this.profileFields.splice(i, 1)
          }
        break;
      }
    }
  }
};
</script>
